export default __webpack_public_path__ + "static/TSD_Header_3_featured-4143ac4232916ab2fd70dff3647716c6.jpg";